module.exports = __webpack_public_path__ + "img/new3.812bd871.png";